import React, { useState } from "react";
import { Button, Icon, Message } from "semantic-ui-react";
import { map, filter, size, uniq, compact } from "lodash";
import { toast } from "react-toastify";
import { OrderItemAdmin } from "../";
import { ModalConfirm } from "../../../Common";
import { useOrder, useAuth } from "../../../../hooks";
import { ORDER_STATUS } from "../../../../utils/constants";
import { countWaitingForArea, getProductionArea } from "../../../../utils/order";
import "./ListOrderAdmin.scss";

export function ListOrderAdmin(props) {
  const { orders, onReloadOrders, batchMode = false } = props;
  const { checkDeliveredOrder } = useOrder();
  const { auth } = useAuth();
  const [delivering, setDelivering] = useState(false);
  const [showForce, setShowForce] = useState(false);

  // WhatsApp, Venta rápida y Delivery salen en un solo lote (una bolsa):
  // "Entregar todo" se habilita cuando nada tiene pendiente su área. Solo el
  // Admin puede entregar antes (cocina caída); el servidor también lo exige.
  const toDeliver = filter(orders, (order) => order.status !== ORDER_STATUS.DELIVERED);
  const waiting = countWaitingForArea(toDeliver);
  const ready = size(toDeliver) - waiting;
  const isAdmin = !!auth?.me?.is_staff;
  // Salón: cada plato espera el "Listo" de su área de producción (Cocina, Bar…).
  const waitingAreas = uniq(
    compact(
      map(
        filter(toDeliver, (order) => order.status === ORDER_STATUS.PENDING),
        getProductionArea
      )
    )
  );

  const deliverAll = async () => {
    setShowForce(false);
    setDelivering(true);
    for (const order of toDeliver) {
      const result = await checkDeliveredOrder(order.id);
      if (!result.ok) {
        toast.error(result.message);
        break;
      }
    }
    setDelivering(false);
    onReloadOrders();
  };

  return (
    <div className="list-orders-admin">
      {!batchMode && size(waitingAreas) > 0 && (
        <Message info size="small">
          <Icon name="clock outline" />
          Hay pedidos esperando a {waitingAreas.join(" y ")}. Podrás entregarlos
          cuando su área los marque "Listo"
          {isAdmin ? " (como Admin puedes entregarlos antes, con confirmación)" : ""}.
        </Message>
      )}
      {batchMode && size(toDeliver) > 0 && (
        <div className={`list-orders-admin__batch${waiting > 0 ? "" : " complete"}`}>
          <div>
            <strong>
              <Icon name="shopping bag" /> Se entrega todo junto, en una bolsa
            </strong>
            <p>
              {waiting > 0
                ? `${ready} de ${size(toDeliver)} listos · faltan ${waiting} por preparar`
                : `Los ${size(toDeliver)} están listos`}
            </p>
          </div>
          <Button
            primary
            loading={delivering}
            disabled={delivering || (waiting > 0 && !isAdmin)}
            onClick={waiting > 0 ? () => setShowForce(true) : deliverAll}
          >
            Entregar todo
          </Button>
        </div>
      )}
      {map(orders, (order) => (
        <OrderItemAdmin
          key={order.id}
          order={order}
          onReloadOrders={onReloadOrders}
          batchMode={batchMode}
        />
      ))}
      <ModalConfirm
        show={showForce}
        title="Faltan pedidos por preparar"
        content={`Faltan ${waiting} por preparar. ¿Entregar todo de todos modos?`}
        onClose={() => setShowForce(false)}
        onCloseText="Volver"
        onConfirm={deliverAll}
        onConfirmText="Sí, entregar todo"
      />
    </div>
  );
}
